import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { ProjectImageData } from 'src/app/project/shared/interfaces/project-image-data.interface';
import { SetAqControl } from 'src/app/project/shared/interfaces/set-aq-control';
import { DataEndChannelService } from 'src/app/project/shared/services/data-end-channel.service';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';

@Component({
  selector: 'avs-set-aq-control',
  standalone: false,
  templateUrl: './set-aq-control.component.html',
  styleUrl: './set-aq-control.component.css'
})
export class SetAqControlComponent implements OnInit, OnChanges {
  @Input() dataEndChannels!: DataEndChannel[];
  @Input() selectedAQControlStellcode?: number;
  @Input() selectedKanalId?: number;
  @Input() selectedAqChannel?: DataEndChannel;
  @Input() images: ProjectImageData[] = [];

  public isFunctionDropdownOpen: boolean = false;
  public functionSelect: SelectInput[] = [{ name: 'Aus', id: 0 }, { name: 'An', id: 1 }/* , { name: 'Blinkend', id: 2 } */];
  public selectedFunction: SelectInput = { name: "Funktion" };

  constructor(private dataEndChannelService: DataEndChannelService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.parseChannelState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedAqChannel'] && this.selectedAqChannel) {
      this.parseChannelState();
    }
  }

  private parseChannelState(): void {
    if (this.selectedAqChannel) {
      let doControl = this.selectedAqChannel.manualControl;
      if (doControl) {
        let parsedDoSettings = JSON.parse(doControl.settings);
        let parsedDo = parsedDoSettings.AQ;
      } else {
        console.log('No manual control found for this channel.');
      }
    }
  }


  public onFunctionItemClicked(item: SelectInput): void {
    this.isFunctionDropdownOpen = false;
    this.selectedFunction.name = item.name
    this.selectedFunction.id = item.id
    let funcId = item.id as number

  }

  public onFunctionDropdownClicked(): void {
    this.isFunctionDropdownOpen = !this.isFunctionDropdownOpen;
  }

  createAqControl(): void {
    this.setAqManualControlImageOn()
  }

  setAqManualControlImageOn(): void {
    let aqControl = {
      active: true,
      code: this.selectedAQControlStellcode ? this.selectedAQControlStellcode : 0,
      function: 1, // '1' means 'on' for the function
      time: 0

    } as SetAqControl;
    this.dataEndChannelService.setAqManualControl(Number(this.selectedAqChannel?.id), aqControl).subscribe(resp => {
      this.alertService.alert('AQ Control wurde erstellt', AlertTypes.success);
    })
  }


  setAqManualControlImageOff(): void {
    if (!this.images || this.images.length === 0) {
      this.alertService.alert('Es muss mindestens 1 Bild vorhanden sein', AlertTypes.error);
      return;
    }


    let aqControl = {
      active: true,
      code: this.images![0].stellcode,
      function: 0, // '0' means 'off' for the function
      time: 0
    } as SetAqControl;
    this.dataEndChannelService.setAqManualControl(Number(this.selectedAqChannel?.id), aqControl).subscribe(resp => {
      this.alertService.alert('AQ Control wurde ausgeschaltet', AlertTypes.success);
    })
  }


  turnAqControlOff(): void {
    let dataEndChannelId = Number(this.selectedAqChannel?.id)
    let aqControl = {
      active: false,
      code: 0,
      function: 0,
      time: 0
    } as SetAqControl;
    this.dataEndChannelService.setAqManualControl(dataEndChannelId, aqControl).subscribe(resp => {
      this.alertService.alert('AQ Control wurde ausgeschaltet', AlertTypes.success);
    })
  }
}
